import { useCurrentCompany, useIsBizyEnabledForUser } from '@bonusly/who-am-i';

import { useUserContentDismissal } from '../profile/user-content-dismissal';
import { MEET_BIZY_PROMO_NAME, MEET_BIZY_PROMO_NAMESPACE } from './meet-bizy-promo-constants';

/** True while the user has Bizy access and has not yet dismissed the Meet Bizy promo. */
export const useHasPendingMeetBizyPromo = () => {
	const isBizyEnabledForUser = useIsBizyEnabledForUser();
	const company = useCurrentCompany();
	const isEligible = isBizyEnabledForUser && !company?.isTrial;
	const { loading, data } = useUserContentDismissal({
		namespace: MEET_BIZY_PROMO_NAMESPACE,
		name: MEET_BIZY_PROMO_NAME,
		enabled: isEligible,
	});

	if (!isEligible) return false;
	// Treat loading as pending so Bizy does not auto-open before we know dismissal state.
	if (loading) return true;
	return !data?.dismissed_at;
};
